import cn from "@lunagoai/vue-ui/components/BaseDialog.vue";
import { defineComponent as he, h as Gt, ref as C, computed as O, reactive as Ft, nextTick as Me, watch as te, onUnmounted as Ge, provide as He, onMounted as Vt, openBlock as d, createElementBlock as w, Fragment as ie, createVNode as V, Transition as Be, withCtx as se, mergeProps as st, withModifiers as N, unref as ne, withDirectives as Je, createElementVNode as b, normalizeStyle as $e, normalizeClass as ee, createCommentVNode as $, toDisplayString as Q, renderSlot as oe, vShow as dt, createTextVNode as fn, createBlock as ve, Teleport as Xt, withKeys as Lt, vModelText as vn, renderList as Se, TransitionGroup as mn, resolveDynamicComponent as ut, createSlots as wn, markRaw as lt } from "vue";
import Z from "@lunagoai/vue-ui/components/BaseIcon.vue";
import { useMobileHistoryEntry as gn } from "@lunagoai/vue-ui/composables/useMobileHistoryEntry";
import { disableCloseWatcherPath as Do, getMobileCloseStack as Ro, useMobileHistoryEntry as Ao } from "@lunagoai/vue-ui/composables/useMobileHistoryEntry";
import hn from "@lunagoai/vue-ui/components/ConfirmationDialog.vue";
import bn from "@lunagoai/vue-ui/components/ToastNotification.vue";
import { confirmQueue as Po, useConfirmDialog as Oo } from "@lunagoai/vue-ui/composables/useConfirmDialog";
import { removeToast as Fo, toasts as Vo, useToast as Xo } from "@lunagoai/vue-ui/composables/useToast";
const yn = he({
  name: "BaseDialog",
  inheritAttrs: !1,
  setup(e, { attrs: i, slots: o }) {
    return () => Gt(cn, i, o);
  }
}), Ce = C([]), jt = C(null), ct = /* @__PURE__ */ new Map();
function ho(e, i) {
  i ? ct.set(e, i) : ct.delete(e);
}
function Bt(e) {
  return ct.get(e) ?? jt.value;
}
function pn(e) {
  Ce.value.find((i) => i.id === e.id) || (Ce.value = [...Ce.value, e]);
}
function xn(e) {
  Ce.value = Ce.value.filter((i) => i.id !== e);
}
const kn = O(() => Ce.value);
function zn() {
  return { minimizedWindows: Ce, globalWindows: kn, dockRef: jt, register: pn, unregister: xn };
}
const Et = 2e3, pe = C([]), Mn = O(() => pe.value.at(-1) ?? null);
function Sn(e) {
  pe.value.includes(e) || (pe.value = [...pe.value, e]);
}
function In(e) {
  pe.value = pe.value.filter((i) => i !== e);
}
function Wn(e) {
  pe.value = [...pe.value.filter((i) => i !== e), e];
}
function $n(e) {
  const i = pe.value.indexOf(e);
  return i === -1 ? Et : Et + i;
}
function wt() {
  return { register: Sn, unregister: In, focus: Wn, getZ: $n, zStack: pe, focusedFloatingId: Mn };
}
const ft = /* @__PURE__ */ new Map();
function Cn(e, i) {
  ft.set(e, i);
}
function bo() {
  for (const e of ft.values())
    try {
      e();
    } catch {
    }
  ft.clear();
}
const yo = "luna:window-exit-state", vt = /* @__PURE__ */ new Map();
function Tn(e, i) {
  i ? vt.set(e, i) : vt.delete(e);
}
function Ln(e) {
  return vt.get(e)?.();
}
const X = C(/* @__PURE__ */ new Map());
function Bn(e) {
  const i = new Map(X.value);
  i.set(e.id, { ...e }), X.value = i;
}
function En(e, i) {
  const o = X.value.get(e);
  if (!o) return;
  const u = new Map(X.value);
  u.set(e, { ...o, visible: i }), X.value = u;
}
function Dn(e) {
  const i = new Map(X.value);
  i.delete(e), X.value = i;
}
function Rn(e, i) {
  const o = X.value.get(e);
  if (!o) return;
  const u = new Map(X.value);
  u.set(e, { ...o, meta: { ...o.meta, ...i } }), X.value = u;
}
function An(e, i) {
  const o = X.value.get(e);
  if (!o) return;
  const u = new Map(X.value);
  u.set(e, { ...o, props: { ...o.props, ...i } }), X.value = u;
}
function Hn(e, i, o) {
  const u = X.value.get(e);
  if (!u) return;
  const y = new Map(X.value);
  y.set(e, { ...u, windowState: i, ...o !== void 0 && { preMinimizeState: o } }), X.value = y;
}
const gt = C(null);
function Pn(e) {
  gt.value = e;
}
const Dt = C(!1);
Cn("windows", () => {
  X.value = /* @__PURE__ */ new Map(), gt.value = null;
});
function On(e, i) {
  const o = X.value.get(e);
  if (!o) return;
  const u = new Map(X.value);
  u.set(e, { ...o, component: i }), X.value = u;
}
function Fe() {
  return { windows: X, openWindow: Bn, setVisible: En, removeWindow: Dn, setMeta: Rn, setProps: An, setWindowState: Hn, setComponent: On, setTransformGetter: Tn, getWindowTransform: Ln, focusedAppId: gt, setFocusedApp: Pn };
}
const U = C([]), Gn = C(null), Fn = C(null), mt = Ft(/* @__PURE__ */ new Set()), _t = O(() => {
  const e = /* @__PURE__ */ new Map();
  for (const i of U.value)
    for (const o of i.tabs) e.set(o.windowId, i.id);
  return e;
});
function ht(...e) {
  for (const i of e) mt.add(i);
  Me(() => {
    for (const i of e) mt.delete(i);
  });
}
function Vn(e, i) {
  const o = crypto.randomUUID();
  return ht(e.windowId, i.windowId), U.value = [...U.value, { id: o, tabs: [e, i], activeWindowId: e.windowId }], o;
}
function Xn(e, i) {
  U.value = U.value.map(
    (o) => o.id === e ? { ...o, activeWindowId: i } : o
  );
}
function jn(e, { transfer: i = !1 } = {}) {
  const o = _t.value.get(e);
  if (!o) return;
  const u = U.value.find((M) => M.id === o);
  if (!u) return;
  i && ht(e);
  const y = u.tabs.filter((M) => M.windowId !== e);
  if (y.length <= 1)
    U.value = U.value.filter((M) => M.id !== o);
  else {
    const M = u.activeWindowId === e ? y[0].windowId : u.activeWindowId;
    U.value = U.value.map(
      (W) => W.id === o ? { ...W, tabs: y, activeWindowId: M } : W
    );
  }
}
function _n(e, i, o) {
  if (i === o) return;
  const u = U.value.find((W) => W.id === e);
  if (!u) return;
  const y = [...u.tabs], [M] = y.splice(i, 1);
  y.splice(o, 0, M), U.value = U.value.map(
    (W) => W.id === e ? { ...W, tabs: y } : W
  );
}
function Kn(e, i) {
  ht(i.windowId), U.value = U.value.map(
    (o) => o.id === e ? { ...o, tabs: [...o.tabs, i], activeWindowId: i.windowId } : o
  );
}
function Yn(e) {
  U.value = U.value.filter((i) => i.id !== e);
}
function Ze() {
  return {
    groups: U,
    draggingWindowId: Gn,
    pendingMerge: Fn,
    windowGroupMap: _t,
    createGroup: Vn,
    addToGroup: Kn,
    setActive: Xn,
    removeTab: jn,
    reorderTab: _n,
    dissolveGroup: Yn,
    pendingTransfers: mt
  };
}
const Kt = C(typeof window < "u" ? window.innerWidth : 1024);
typeof window < "u" && window.addEventListener("resize", () => {
  Kt.value = window.innerWidth;
}, { passive: !0 });
function Nn(e = 640) {
  return O(() => Kt.value < e);
}
const Un = { class: "p-1.5 rounded-full hover:bg-gray-100 dark:hover:bg-dark-200 flex items-center justify-center text-gray-400 hover:text-gray-600 dark:hover:text-dark-text" }, Jn = ["title", "aria-label"], Zn = {
  key: 0,
  class: "flex items-center gap-2 min-w-0"
}, Qn = { class: "text-sm font-medium truncate" }, qn = {
  key: 0,
  class: "flex items-center gap-2 min-w-0"
}, ei = { class: "text-sm font-medium truncate" }, ti = {
  key: 0,
  class: "shrink-0 text-xs font-normal text-gray-400 dark:text-gray-500"
}, ni = {
  key: 1,
  class: "text-base md:text-lg font-bold text-gray-900 dark:text-dark-text flex items-baseline gap-1.5 min-w-0"
}, ii = { class: "truncate" }, oi = {
  key: 0,
  class: "shrink-0 text-sm font-normal text-gray-400 dark:text-gray-500"
}, ai = ["title", "aria-label"], li = ["title", "aria-label"], ri = ["title", "aria-label"], si = {
  key: 0,
  class: "flex items-center"
}, di = {
  key: 0,
  class: "w-px h-6 bg-gray-100 dark:bg-dark-200 mx-1.5 sm:mx-2.5"
}, ui = ["title", "aria-label"], ci = { class: "p-1.5 rounded-full hover:bg-gray-100 dark:hover:bg-dark-200 flex items-center justify-center text-gray-400 hover:text-gray-600 dark:hover:text-dark-text" }, fi = ["title", "aria-label"], vi = { class: "p-1.5 rounded-full hover:bg-gray-100 dark:hover:bg-dark-200 flex items-center justify-center text-gray-400 hover:text-gray-600 dark:hover:text-dark-text" }, mi = ["title", "aria-label"], wi = { class: "p-1.5 rounded-full hover:bg-gray-100 dark:hover:bg-dark-200 flex items-center justify-center text-gray-400 hover:text-gray-600 dark:hover:text-dark-text" }, gi = {
  key: 1,
  class: "border-t border-gray-100 dark:border-dark-200 bg-gray-50/50 dark:bg-dark-100/50 rounded-b-xl shrink-0 px-6 py-4"
}, hi = { class: "flex items-center justify-end gap-2 w-full" }, bi = {
  key: 0,
  class: "absolute inset-0 z-50 bg-primary/10 border-2 border-dashed border-primary flex items-center justify-center pointer-events-none rounded-xl"
}, yi = { class: "bg-primary text-white px-3 py-1.5 rounded-lg text-sm font-medium shadow-lg flex items-center gap-1.5" }, Rt = 12, At = 20, Le = 300, Ue = 200, pi = 100, xi = /* @__PURE__ */ he({
  inheritAttrs: !1,
  __name: "BaseWindow",
  props: {
    windowId: {},
    title: {},
    titleSuffix: {},
    icon: { default: "AppWindow" },
    visible: { type: Boolean },
    closable: { type: Boolean, default: !0 },
    closeOnEscape: { type: Boolean, default: !1 },
    minimizable: { type: Boolean, default: !1 },
    maximizable: { type: Boolean, default: !1 },
    maximized: { type: Boolean },
    mergeable: { type: Boolean, default: !1 },
    draggable: { type: Boolean, default: !0 },
    maxWidth: { default: "md" },
    width: {},
    height: {},
    minHeight: {},
    resizable: { type: Boolean, default: !1 },
    resizeStorageKey: {},
    contentClass: {},
    bodyClass: {},
    bodyOverflow: { default: "auto" },
    mobilePresentation: { default: "inline" },
    customBack: { type: Boolean, default: !1 },
    mobileBack: { type: Boolean, default: !1 },
    hideHeaderMobile: { type: Boolean, default: !1 },
    keyboardAware: { type: Boolean, default: !1 },
    labels: {}
  },
  emits: ["update:visible", "update:minimized", "after-hide", "close", "back", "show", "after-show", "viewport-resize"],
  setup(e, { expose: i, emit: o }) {
    const u = wt(), { windows: y, setFocusedApp: M, focusedAppId: W, setTransformGetter: H, setWindowState: R } = Fe(), T = Ze(), B = Nn(), g = {
      mergeGrip: "Drag to merge window",
      minimize: "Minimize",
      restore: "Restore window",
      close: "Close",
      maximize: "Maximize",
      mergeDrop: "Merge into tabbed window"
    }, t = e, r = O(() => ({ ...g, ...t.labels })), p = o, f = O(
      () => t.windowId ? u.getZ(t.windowId) : 2e3
    );
    function _() {
      t.windowId && u.focus(t.windowId);
    }
    te(() => t.windowId, (n, l) => {
      l && (u.unregister(l), H(l, void 0)), n && (u.register(n), H(n, () => P.value));
    }, { immediate: !0 }), Ge(() => {
      t.windowId && (u.unregister(t.windowId), H(t.windowId, void 0));
    });
    const k = C(
      t.windowId ? y.value.get(t.windowId)?.windowState ?? (t.maximized ? "maximized" : "floating") : t.maximized ? "maximized" : "floating"
    );
    let j = k.value !== "minimized" ? k.value : t.windowId ? y.value.get(t.windowId)?.preMinimizeState ?? "floating" : "floating";
    const h = O(() => k.value === "maximized"), m = O(() => k.value === "minimized"), S = O(() => k.value === "tiled-left" || k.value === "tiled-right"), v = O(() => h.value || S.value), D = C(!1);
    let K;
    function x() {
      clearTimeout(K), D.value = !0, K = setTimeout(() => {
        D.value = !1;
      }, 800);
    }
    He("windowMaximized", h);
    let c = null;
    function I() {
      c = ke.value?.getBoundingClientRect() ?? null, j = k.value === "floating" ? "floating" : k.value, k.value = "minimized";
    }
    te([v, () => t.visible], ([n, l]) => {
      t.windowId && (n && l ? M(t.windowId) : W.value === t.windowId && M(null));
    }, { immediate: !0 }), te(k, (n) => {
      t.windowId && R(t.windowId, n, n === "minimized" ? j : void 0);
    }), te(() => t.windowId ? y.value.get(t.windowId)?.windowState : void 0, (n) => {
      n && n !== k.value && (k.value = n);
    }), He("windowId", O(() => t.windowId ?? ""));
    const a = O(() => t.mobilePresentation === "overlay" && B.value), A = O(() => {
      const n = {
        sm: "max-w-sm w-full",
        md: "max-w-md w-full",
        lg: "max-w-lg w-full",
        xl: "max-w-xl w-full",
        "2xl": "max-w-2xl w-full",
        "3xl": "max-w-3xl w-full",
        "4xl": "max-w-4xl w-full",
        "5xl": "max-w-5xl w-full",
        "6xl": "max-w-6xl w-full",
        "7xl": "max-w-7xl w-full",
        "8xl": "max-w-8xl w-full",
        full: "max-w-full w-full",
        none: ""
      };
      return n[t.maxWidth] || n.md;
    }), z = O(() => `w-full h-full max-w-full sm:w-full sm:h-auto sm:max-h-[90vh] ${{
      sm: "sm:max-w-sm",
      md: "sm:max-w-md",
      lg: "sm:max-w-lg",
      xl: "sm:max-w-xl",
      "2xl": "sm:max-w-2xl",
      "3xl": "sm:max-w-3xl",
      "4xl": "sm:max-w-4xl",
      "5xl": "sm:max-w-5xl",
      "6xl": "sm:max-w-6xl",
      "7xl": "sm:max-w-7xl",
      "8xl": "sm:max-w-8xl",
      full: "sm:max-w-full",
      none: ""
    }[t.maxWidth] || "sm:max-w-md"}`), ae = O(() => {
      const n = {};
      if ((P.value.x !== 0 || P.value.y !== 0) && (n["--window-tx"] = `${P.value.x}px`, n["--window-ty"] = `${P.value.y}px`), le.value ? (n.width = `${le.value}px`, n.maxWidth = `${le.value}px`, n.minWidth = "0") : t.width && t.width !== "auto" && (n.width = t.width, n.maxWidth = t.width, n.minWidth = "0"), t.keyboardAware && We.value) {
        const s = B.value ? We.value : Math.min(We.value - 48, 700);
        n.height = `${s}px`, n.maxHeight = `${s}px`;
      } else q.value && (n.height = `${q.value}px`, n.maxHeight = `${q.value}px`);
      return n;
    }), de = O(() => {
      if (v.value) return {};
      const n = {};
      return !a.value && !q.value && (t.height && (n.height = t.height), t.minHeight && (n.minHeight = t.minHeight)), n;
    }), Ve = O(() => {
      const n = "var(--shell-sidebar-width, 0px)";
      return k.value === "tiled-left" ? { left: n, width: `calc((100vw - ${n}) / 2)` } : k.value === "tiled-right" ? { left: `calc(${n} + (100vw - ${n}) / 2)`, width: `calc((100vw - ${n}) / 2)` } : { left: n };
    });
    function Te() {
      const n = document.documentElement.style, l = parseFloat(n.getPropertyValue("--shell-inset-left")) || 0, s = parseFloat(n.getPropertyValue("--shell-inset-right")) || 0, L = parseFloat(n.getPropertyValue("--shell-inset-top")) || 0, G = parseFloat(n.getPropertyValue("--shell-inset-bottom")) || 0;
      return {
        availableW: window.innerWidth - l - s,
        availableH: window.innerHeight - L - G,
        insetLeft: l,
        insetTop: L
      };
    }
    const Nt = t.windowId ? y.value.get(t.windowId) : void 0, P = C(Nt?.initialTransform ?? { x: 0, y: 0 }), Xe = C(!1);
    let me = 0, we = 0, qe = 0, et = 0, Ee = !1, je = !1;
    function bt(n) {
      n.preventDefault();
    }
    function Ut(n) {
      if (!(!t.draggable || B.value || a.value || n.target.closest('button, a, input, textarea, [draggable="true"]'))) {
        if (je = h.value, S.value) {
          const L = ke.value?.getBoundingClientRect(), G = L ? L.width / 2 : 200;
          k.value = "floating", me = n.clientX - G, we = n.clientY - At, P.value = { x: me, y: we };
        } else
          me = P.value.x, we = P.value.y;
        Xe.value = !0, Dt.value = !0, Ee = !1, qe = n.clientX - me, et = n.clientY - we, document.addEventListener("dragstart", bt, !0), document.addEventListener("mousemove", tt), document.addEventListener("mouseup", _e);
      }
    }
    const xe = C(null);
    function tt(n) {
      if (!Xe.value) return;
      if (n.buttons === 0) {
        _e();
        return;
      }
      if (!Ee) {
        if (Ee = !0, n.preventDefault(), je) {
          Mt(), ue?.cancel(), ue = null, k.value = "floating";
          const { availableW: G, availableH: E, insetLeft: Y, insetTop: ce } = Te(), be = Math.round(Y + G / 2), fe = Math.round(ce + E / 2), ye = Math.max(0, Math.min(1, (n.clientX - Y) / G)), J = le.value || 800, F = q.value || 600;
          me = n.clientX - be + J * (0.5 - ye), we = n.clientY - At - fe + F / 2, qe = n.clientX - me, et = n.clientY - we, P.value = { x: me, y: we };
        }
        const L = ke.value;
        L && (L.style.willChange = "transform", L.style.pointerEvents = "none", L.style.userSelect = "none", L.classList.add("window-dragging"));
      }
      me = n.clientX - qe, we = n.clientY - et;
      const l = ke.value;
      l && (l.style.setProperty("--window-tx", `${me}px`), l.style.setProperty("--window-ty", `${we}px`));
      const s = xe.value;
      n.clientX <= Rt ? xe.value = "left" : n.clientX >= window.innerWidth - Rt ? xe.value = "right" : xe.value = null, xe.value !== s && (P.value = { x: me, y: we });
    }
    function _e() {
      const n = xe.value;
      xe.value = null, Xe.value = !1, Dt.value = !1;
      const l = ke.value;
      l && (l.style.willChange = "", l.style.pointerEvents = "", l.style.userSelect = "", l.classList.remove("window-dragging")), n && !B.value ? k.value = n === "left" ? "tiled-left" : "tiled-right" : (!je || Ee) && (P.value = { x: me, y: we }), Ee = !1, je = !1, document.removeEventListener("dragstart", bt, !0), document.removeEventListener("mousemove", tt), document.removeEventListener("mouseup", _e);
    }
    function Jt() {
      P.value = { x: 0, y: 0 };
    }
    function Zt() {
      if (!t.resizeStorageKey) return null;
      try {
        const n = localStorage.getItem(t.resizeStorageKey);
        if (n) {
          const { w: l, h: s } = JSON.parse(n);
          if (typeof l == "number" && typeof s == "number") return { w: l, h: s };
        }
      } catch {
      }
      return null;
    }
    const yt = Zt(), le = C(yt?.w ?? null), q = C(yt?.h ?? null), Ke = C(!1), pt = C("se"), xt = C({ mouseX: 0, mouseY: 0, width: 0, height: 0, tx: 0, ty: 0 });
    function kt() {
      if (!(!t.resizeStorageKey || !le.value || !q.value))
        try {
          localStorage.setItem(t.resizeStorageKey, JSON.stringify({ w: le.value, h: q.value }));
        } catch {
        }
    }
    function ze(n, l) {
      if (!t.resizable) return;
      n.preventDefault(), n.stopPropagation(), _();
      const s = ke.value;
      if (!s) return;
      const L = s.getBoundingClientRect();
      Ke.value = !0, pt.value = l, xt.value = { mouseX: n.clientX, mouseY: n.clientY, width: L.width, height: L.height, tx: P.value.x, ty: P.value.y }, document.addEventListener("mousemove", nt), document.addEventListener("mouseup", Ye);
    }
    function nt(n) {
      if (!Ke.value) return;
      if (n.buttons === 0) {
        Ye();
        return;
      }
      const { mouseX: l, mouseY: s, width: L, height: G, tx: E, ty: Y } = xt.value, ce = n.clientX - l, be = n.clientY - s, fe = window.innerWidth, ye = window.innerHeight, J = pt.value;
      if (J === "s") {
        const F = Math.min(ye, Math.max(Ue, G + be));
        q.value = F, P.value = { x: E, y: Y + (F - G) / 2 };
      } else if (J === "n") {
        const F = Math.min(ye, Math.max(Ue, G - be));
        q.value = F, P.value = { x: E, y: Y - (F - G) / 2 };
      } else if (J === "e") {
        const F = Math.min(fe, Math.max(Le, L + ce));
        le.value = F, P.value = { x: E + (F - L) / 2, y: Y };
      } else if (J === "w") {
        const F = Math.min(fe, Math.max(Le, L - ce));
        le.value = F, P.value = { x: E - (F - L) / 2, y: Y };
      } else if (J === "se" || J === "sw") {
        const F = Math.min(ye, Math.max(Ue, G + be));
        q.value = F;
        const re = J === "se" ? Math.min(fe, Math.max(Le, L + ce)) : Math.min(fe, Math.max(Le, L - ce));
        le.value = re, P.value = { x: J === "se" ? E + (re - L) / 2 : E - (re - L) / 2, y: Y + (F - G) / 2 };
      } else {
        const F = Math.min(ye, Math.max(Ue, G - be));
        q.value = F;
        const re = J === "ne" ? Math.min(fe, Math.max(Le, L + ce)) : Math.min(fe, Math.max(Le, L - ce));
        le.value = re, P.value = { x: J === "ne" ? E + (re - L) / 2 : E - (re - L) / 2, y: Y - (F - G) / 2 };
      }
      if (J !== "n" && J !== "ne" && J !== "nw") {
        const re = ((q.value ?? G) - window.innerHeight) / 2;
        P.value.y < re && (P.value = { x: P.value.x, y: re });
      }
    }
    function Ye() {
      Ke.value = !1, kt(), document.removeEventListener("mousemove", nt), document.removeEventListener("mouseup", Ye);
    }
    const De = C(null);
    let ue = null;
    async function zt() {
      if (k.value === "maximized") return;
      const n = De.value?.getBoundingClientRect() ?? null;
      if (k.value = "maximized", await Me(), k.value !== "maximized") return;
      const l = De.value;
      if (!l || !n) return;
      ue?.cancel();
      const s = l.getBoundingClientRect(), L = n.left + n.width / 2 - (s.left + s.width / 2), G = n.top + n.height / 2 - (s.top + s.height / 2), E = Math.min(n.width / s.width, n.height / s.height);
      ue = l.animate([
        { transform: `translate(${L}px, ${G}px) scale(${E})`, borderRadius: "0.75rem" },
        { transform: "none", borderRadius: "0rem" }
      ], { duration: 300, easing: "cubic-bezier(0.25, 0.46, 0.45, 0.94)" }), ue.finished.then(() => {
        ue = null;
      }).catch(() => {
      });
    }
    function Mt() {
      if (!q.value && !le.value) {
        const { availableW: n, availableH: l } = Te();
        le.value = Math.round(Math.min(n * 0.75, 1152)), q.value = Math.round(l * 0.8), kt();
      }
    }
    async function St() {
      if (k.value === "floating") return;
      const n = De.value?.getBoundingClientRect() ?? null;
      if (Mt(), k.value = "floating", await Me(), k.value !== "floating") return;
      const l = De.value;
      if (!l || !n) return;
      ue?.cancel();
      const s = l.getBoundingClientRect(), L = n.left + n.width / 2 - (s.left + s.width / 2), G = n.top + n.height / 2 - (s.top + s.height / 2), E = Math.min(n.width / s.width, n.height / s.height);
      ue = l.animate([
        { transform: `translate(${L}px, ${G}px) scale(${E})`, borderRadius: "0rem" },
        { transform: "none", borderRadius: "0.75rem" }
      ], { duration: 280, easing: "cubic-bezier(0.25, 0.46, 0.45, 0.94)" }), ue.finished.then(() => {
        ue = null;
      }).catch(() => {
      });
    }
    const Ie = C(k.value === "minimized");
    let ge = null;
    const { register: It, unregister: Wt } = zn();
    te(m, (n) => {
      p("update:minimized", n), !(!t.minimizable || !t.windowId) && (n ? It({
        id: t.windowId,
        title: t.title,
        icon: t.icon,
        restore: () => {
          const l = m.value;
          k.value = j, t.windowId && u.focus(t.windowId), l || x();
        },
        close: () => p("update:visible", !1)
      }) : Wt(t.windowId));
    }), Ge(() => {
      t.windowId && Wt(t.windowId), clearTimeout(K);
    }), te(m, async (n) => {
      ge?.cancel(), ge = null;
      const l = ke.value;
      if (!l) {
        Ie.value = n;
        return;
      }
      if (n) {
        await Me();
        const s = Bt(t.windowId)?.getBoundingClientRect() ?? null, L = s ? s.left + s.width / 2 : 24, G = s ? s.top + s.height / 2 : window.innerHeight - 24, E = l.getBoundingClientRect(), Y = c ?? E;
        c = null;
        const ce = Y.left + Y.width / 2 - (E.left + E.width / 2), be = Y.top + Y.height / 2 - (E.top + E.height / 2), fe = Math.min(Y.width / E.width, Y.height / E.height), ye = L - (E.left + E.width / 2), J = G - (E.top + E.height / 2), F = s ? Math.max(s.width / E.width, 0.05) : 0.05, re = P.value.x, Tt = P.value.y;
        ge = l.animate([
          { transform: `translate(${ce + re}px, ${be + Tt}px) scale(${fe})`, opacity: 1 },
          { transform: `translate(${ye + re}px, ${J + Tt}px) scale(${F})`, opacity: 0 }
        ], { duration: 220, easing: "cubic-bezier(0.4, 0, 1, 1)", fill: "forwards" }), await ge.finished.catch(() => {
        }), Ie.value = !0, ge?.cancel(), ge = null;
      } else {
        Ie.value = !1, await Me();
        const s = Bt(t.windowId)?.getBoundingClientRect() ?? null, L = s ? s.left + s.width / 2 : 24, G = s ? s.top + s.height / 2 : window.innerHeight - 24, E = l.getBoundingClientRect(), Y = s ? Math.max(s.width / E.width, 0.05) : 0.05, ce = L - (E.left + E.width / 2), be = G - (E.top + E.height / 2), fe = P.value.x, ye = P.value.y;
        ge = l.animate([
          { transform: `translate(${ce + fe}px, ${be + ye}px) scale(${Y})`, opacity: 0 },
          { opacity: 1 }
        ], { duration: 280, easing: "cubic-bezier(0, 0, 0.2, 1)" }), await ge.finished.catch(() => {
        }), ge = null;
      }
    });
    const Re = C(!1);
    function Qt(n) {
      t.windowId && (T.draggingWindowId.value = t.windowId, n.dataTransfer?.setData("text/plain", t.windowId));
    }
    function qt() {
      T.draggingWindowId.value = null, Re.value = !1;
    }
    function en() {
      const n = T.draggingWindowId.value;
      n && n !== t.windowId && t.mergeable && t.windowId && (Re.value = !0);
    }
    function tn() {
      Re.value = !1;
    }
    function nn() {
      const n = T.draggingWindowId.value;
      n && n !== t.windowId && t.mergeable && t.windowId && (T.pendingMerge.value = { from: n, to: t.windowId }, T.draggingWindowId.value = null), Re.value = !1;
    }
    const We = C(null);
    let Ne = null, it = 0;
    Vt(() => {
      if (m.value && t.minimizable && t.windowId && It({
        id: t.windowId,
        title: t.title,
        icon: t.icon,
        restore: () => {
          const n = m.value;
          k.value = j, t.windowId && u.focus(t.windowId), n || x();
        },
        close: () => p("update:visible", !1)
      }), t.keyboardAware && window.visualViewport) {
        it = window.visualViewport.height;
        let n = !1;
        Ne = () => {
          const l = window.visualViewport.height, s = it - l;
          s > pi && !n ? (n = !0, We.value = l, p("viewport-resize", l)) : s < 50 && n && (n = !1, We.value = null, p("viewport-resize", it));
        }, window.visualViewport.addEventListener("resize", Ne);
      }
    });
    function Ae() {
      p("update:visible", !1), p("close");
    }
    function ot(n) {
      t.visible && t.closeOnEscape && n.key === "Escape" && Ae();
    }
    function on(n) {
      t.maximizable && !a.value && !B.value && !n.target.closest("button, a, input") && (v.value ? St() : zt());
    }
    const { push: an, consume: ln, pushBackStep: rn, popBackStep: sn } = gn();
    function dn() {
      p("after-show");
    }
    function un() {
      Jt(), p("after-hide");
    }
    const ke = C(null);
    te(() => t.visible, (n) => {
      n ? (p("show"), window.addEventListener("keydown", ot), t.mobilePresentation === "overlay" && window.innerWidth < 640 && an(Ae)) : (window.removeEventListener("keydown", ot), ln());
    }, { immediate: !0 }), Ge(() => {
      t.windowId && W.value === t.windowId && M(null), window.removeEventListener("keydown", ot), document.removeEventListener("mousemove", tt), document.removeEventListener("mouseup", _e), document.removeEventListener("mousemove", nt), document.removeEventListener("mouseup", Ye), Ne && window.visualViewport?.removeEventListener("resize", Ne), ge?.cancel(), ge = null, c = null, ue?.cancel(), ue = null;
    });
    const $t = C(null);
    He("windowPortal", $t);
    const Ct = C(0);
    He("windowBackdropDepth", Ct);
    const at = C([]);
    return He("windowBackdropHandlers", at), i({ pushBackStep: rn, popBackStep: sn, wrapperRef: ke }), (n, l) => (d(), w(ie, null, [
      V(Be, {
        name: a.value ? "window-slide" : "window",
        appear: "",
        onAfterEnter: dn,
        onAfterLeave: un
      }, {
        default: se(() => [
          e.visible ? (d(), w("div", st({ key: 0 }, n.$attrs, {
            class: ["inset-0", v.value ? [ne(B) ? "absolute" : "fixed", "flex flex-col"] : [
              "fixed",
              "flex justify-center pointer-events-none",
              a.value ? "sm:p-6" : "",
              {
                "select-none": Ke.value,
                "items-start": e.keyboardAware && !!We.value && a.value,
                "items-center": !(e.keyboardAware && We.value && a.value)
              }
            ]],
            style: {
              zIndex: f.value,
              ...v.value ? Ve.value : {},
              ...!v.value && !a.value ? {
                paddingLeft: "calc(var(--shell-inset-left, 0px) + 1.5rem)",
                paddingRight: "calc(var(--shell-inset-right, 0px) + 1.5rem)",
                paddingTop: "calc(var(--shell-inset-top, 0px) + 1.5rem)",
                paddingBottom: "calc(var(--shell-inset-bottom, 0px) + 1.5rem)"
              } : {}
            },
            onMousedown: N(_, ["stop"])
          }), [
            Je(b("div", {
              ref_key: "wrapperRef",
              ref: ke,
              class: ee(["relative flex flex-col origin-center", v.value ? "flex-1 min-h-0 w-full pointer-events-auto z-10" : ["window-scale-wrapper pointer-events-auto z-10", le.value ? "shrink-0" : "", a.value ? z.value : `${A.value} ${q.value ? "" : "max-h-[90vh]"}`]]),
              style: $e(v.value ? {} : ae.value)
            }, [
              b("div", {
                ref_key: "panelRef",
                ref: De,
                class: ee(["relative bg-white dark:bg-dark-100 shadow-2xl w-full h-full flex flex-col overflow-hidden border border-transparent dark:border-dark-200 contain-layout-paint", [e.contentClass, v.value ? "" : a.value ? "max-h-full rounded-none sm:rounded-xl" : "rounded-xl", { "window-focus-ring": D.value }]]),
                style: $e(de.value),
                role: "dialog",
                onDragover: N(en, ["prevent"]),
                onDragleave: tn,
                onDrop: N(nn, ["prevent"])
              }, [
                n.$slots.header || e.title || e.closable ? (d(), w("div", {
                  key: 0,
                  class: ee(["base-dialog-header border-b border-gray-100 dark:border-dark-200 flex items-center shrink-0 transition-all duration-500", [
                    v.value ? "h-10 px-3" : "min-h-12 md:min-h-14 px-6 py-3",
                    { "cursor-move select-none": e.draggable && !ne(B) && !a.value },
                    { "max-sm:hidden": e.hideHeaderMobile }
                  ]]),
                  style: $e(a.value ? { paddingTop: "env(safe-area-inset-top)" } : {}),
                  onMousedown: l[5] || (l[5] = (s) => Ut(s)),
                  onDragstart: l[6] || (l[6] = N(() => {
                  }, ["prevent"])),
                  onDblclick: on
                }, [
                  e.closable && (a.value && !h.value || h.value && ne(B) && e.mobileBack) ? (d(), w("button", {
                    key: 0,
                    onClick: l[0] || (l[0] = (s) => h.value && ne(B) && e.mobileBack || e.customBack ? p("back") : Ae()),
                    class: "flex items-center justify-center mr-2 shrink-0 transition-colors"
                  }, [
                    b("div", Un, [
                      V(Z, {
                        name: "ArrowLeft",
                        size: 18
                      })
                    ])
                  ])) : $("", !0),
                  e.mergeable && e.windowId && !ne(B) && !a.value && !h.value ? (d(), w("div", {
                    key: 1,
                    class: "cursor-grab active:cursor-grabbing p-1 mr-1 text-gray-300 hover:text-gray-500 dark:text-gray-600 dark:hover:text-gray-400 shrink-0 touch-none",
                    draggable: "true",
                    title: r.value.mergeGrip,
                    "aria-label": r.value.mergeGrip,
                    onDragstart: N(Qt, ["stop"]),
                    onDragend: N(qt, ["stop"])
                  }, [
                    V(Z, {
                      name: "GripVertical",
                      size: 14
                    })
                  ], 40, Jn)) : $("", !0),
                  b("div", {
                    class: ee(["flex-1 min-w-0", v.value || a.value ? "flex items-center" : "mr-4"])
                  }, [
                    a.value ? (d(), w("div", Zn, [
                      V(Z, {
                        name: e.icon,
                        size: 15,
                        class: "text-primary shrink-0"
                      }, null, 8, ["name"]),
                      b("span", Qn, Q(e.title), 1)
                    ])) : oe(n.$slots, "header", { key: 1 }, () => [
                      v.value ? (d(), w("div", qn, [
                        V(Z, {
                          name: e.icon,
                          size: 15,
                          class: "text-primary shrink-0"
                        }, null, 8, ["name"]),
                        b("span", ei, Q(e.title), 1),
                        e.titleSuffix ? (d(), w("span", ti, Q(e.titleSuffix), 1)) : $("", !0)
                      ])) : (d(), w("h3", ni, [
                        b("span", ii, Q(e.title), 1),
                        e.titleSuffix ? (d(), w("span", oi, Q(e.titleSuffix), 1)) : $("", !0)
                      ]))
                    ], !0)
                  ], 2),
                  b("div", {
                    class: ee(["flex items-center shrink-0", v.value ? "gap-0.5" : "gap-1"])
                  }, [
                    v.value ? (d(), w(ie, { key: 0 }, [
                      oe(n.$slots, "actions", {}, void 0, !0),
                      ne(B) ? $("", !0) : (d(), w(ie, { key: 0 }, [
                        e.minimizable ? (d(), w("button", {
                          key: 0,
                          onClick: l[1] || (l[1] = (s) => I()),
                          class: "w-7 h-7 flex items-center justify-center rounded-md text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 hover:bg-gray-200 dark:hover:bg-dark-200 transition-colors",
                          title: r.value.minimize,
                          "aria-label": r.value.minimize
                        }, [
                          V(Z, {
                            name: "Minus",
                            size: 14
                          })
                        ], 8, ai)) : $("", !0),
                        e.maximizable ? (d(), w("button", {
                          key: 1,
                          onClick: l[2] || (l[2] = (s) => St()),
                          class: "w-7 h-7 flex items-center justify-center rounded-md text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 hover:bg-gray-200 dark:hover:bg-dark-200 transition-colors",
                          title: r.value.restore,
                          "aria-label": r.value.restore
                        }, [
                          V(Z, {
                            name: "Minimize2",
                            size: 14
                          })
                        ], 8, li)) : $("", !0),
                        e.closable ? (d(), w("button", {
                          key: 2,
                          onClick: Ae,
                          class: "w-7 h-7 flex items-center justify-center rounded-md text-gray-400 hover:text-red-500 hover:bg-red-50 dark:hover:bg-red-900/20 transition-colors",
                          title: r.value.close,
                          "aria-label": r.value.close
                        }, [
                          V(Z, {
                            name: "X",
                            size: 14
                          })
                        ], 8, ri)) : $("", !0)
                      ], 64))
                    ], 64)) : (d(), w(ie, { key: 1 }, [
                      n.$slots.actions ? (d(), w("div", si, [
                        oe(n.$slots, "actions", {}, void 0, !0),
                        a.value ? $("", !0) : (d(), w("div", di))
                      ])) : $("", !0),
                      e.minimizable && e.closable && !ne(B) && !a.value ? (d(), w("button", {
                        key: 1,
                        onClick: l[3] || (l[3] = (s) => I()),
                        class: "flex items-center justify-center transition-colors",
                        title: r.value.minimize,
                        "aria-label": r.value.minimize
                      }, [
                        b("div", ci, [
                          V(Z, {
                            name: "Minus",
                            size: 14
                          })
                        ])
                      ], 8, ui)) : $("", !0),
                      e.maximizable && e.closable && !a.value ? (d(), w("button", {
                        key: 2,
                        onClick: l[4] || (l[4] = (s) => zt()),
                        class: "flex items-center justify-center transition-colors",
                        title: r.value.maximize,
                        "aria-label": r.value.maximize
                      }, [
                        b("div", vi, [
                          V(Z, {
                            name: "Maximize2",
                            size: 14
                          })
                        ])
                      ], 8, fi)) : $("", !0),
                      e.closable && !a.value ? (d(), w("button", {
                        key: 3,
                        onClick: Ae,
                        class: "flex items-center justify-center transition-colors",
                        title: r.value.close,
                        "aria-label": r.value.close
                      }, [
                        b("div", wi, [
                          V(Z, {
                            name: "X",
                            size: 14
                          })
                        ])
                      ], 8, mi)) : $("", !0)
                    ], 64))
                  ], 2)
                ], 38)) : $("", !0),
                Je(b("div", {
                  class: ee(["flex-1", [e.bodyClass, e.bodyOverflow === "hidden" || v.value ? "overflow-hidden" : "overflow-y-auto", e.bodyOverflow === "hidden" || v.value ? "min-h-0" : "px-6 py-4", { "pointer-events-none": Xe.value }]])
                }, [
                  oe(n.$slots, "default", {}, void 0, !0)
                ], 2), [
                  [dt, !Ie.value]
                ]),
                n.$slots.footer && !Ie.value && !v.value ? (d(), w("div", gi, [
                  b("div", hi, [
                    oe(n.$slots, "footer", {}, void 0, !0)
                  ])
                ])) : $("", !0),
                V(Be, {
                  "enter-active-class": "transition duration-150 ease-out",
                  "enter-from-class": "opacity-0",
                  "enter-to-class": "opacity-100",
                  "leave-active-class": "transition duration-100 ease-in",
                  "leave-from-class": "opacity-100",
                  "leave-to-class": "opacity-0"
                }, {
                  default: se(() => [
                    Re.value ? (d(), w("div", bi, [
                      b("div", yi, [
                        V(Z, {
                          name: "LayoutGrid",
                          size: 14
                        }),
                        fn(" " + Q(r.value.mergeDrop), 1)
                      ])
                    ])) : $("", !0)
                  ]),
                  _: 1
                })
              ], 38),
              V(Be, {
                "enter-active-class": "transition-opacity duration-200",
                "leave-active-class": "transition-opacity duration-200",
                "enter-from-class": "opacity-0",
                "leave-to-class": "opacity-0"
              }, {
                default: se(() => [
                  Ct.value > 0 ? (d(), w("div", {
                    key: 0,
                    class: ee(["absolute inset-0 bg-black/40 pointer-events-auto", v.value ? "" : "rounded-xl"]),
                    onClick: l[7] || (l[7] = (s) => at.value[at.value.length - 1]?.())
                  }, null, 2)) : $("", !0)
                ]),
                _: 1
              }),
              e.resizable && !v.value && !a.value && !Ie.value ? (d(), w(ie, { key: 0 }, [
                b("div", {
                  class: "absolute right-0 top-0 w-2 h-full cursor-ew-resize z-20",
                  onMousedown: l[8] || (l[8] = N((s) => ze(s, "e"), ["stop"]))
                }, null, 32),
                b("div", {
                  class: "absolute left-0 top-0 w-2 h-full cursor-ew-resize z-20",
                  onMousedown: l[9] || (l[9] = N((s) => ze(s, "w"), ["stop"]))
                }, null, 32),
                b("div", {
                  class: "absolute top-0 left-0 h-2 w-full cursor-ns-resize z-20",
                  onMousedown: l[10] || (l[10] = N((s) => ze(s, "n"), ["stop"]))
                }, null, 32),
                b("div", {
                  class: "absolute bottom-0 left-0 h-2 w-full cursor-ns-resize z-20",
                  onMousedown: l[11] || (l[11] = N((s) => ze(s, "s"), ["stop"]))
                }, null, 32),
                b("div", {
                  class: "absolute top-0 right-0 w-5 h-5 cursor-nesw-resize z-30",
                  onMousedown: l[12] || (l[12] = N((s) => ze(s, "ne"), ["stop"]))
                }, null, 32),
                b("div", {
                  class: "absolute top-0 left-0 w-5 h-5 cursor-nwse-resize z-30",
                  onMousedown: l[13] || (l[13] = N((s) => ze(s, "nw"), ["stop"]))
                }, null, 32),
                b("div", {
                  class: "absolute bottom-0 right-0 w-5 h-5 cursor-nwse-resize z-30 group/rs",
                  onMousedown: l[14] || (l[14] = N((s) => ze(s, "se"), ["stop"]))
                }, [...l[16] || (l[16] = [
                  b("svg", {
                    class: "absolute bottom-0.5 right-0.5 w-2.5 h-2.5 text-gray-300 dark:text-gray-600 opacity-0 group-hover/rs:opacity-100 transition-opacity",
                    viewBox: "0 0 10 10"
                  }, [
                    b("path", {
                      d: "M9 1L1 9M9 5L5 9",
                      stroke: "currentColor",
                      "stroke-width": "1.5",
                      "stroke-linecap": "round"
                    })
                  ], -1)
                ])], 32),
                b("div", {
                  class: "absolute bottom-0 left-0 w-5 h-5 cursor-nesw-resize z-30 group/rs",
                  onMousedown: l[15] || (l[15] = N((s) => ze(s, "sw"), ["stop"]))
                }, [...l[17] || (l[17] = [
                  b("svg", {
                    class: "absolute bottom-0.5 left-0.5 w-2.5 h-2.5 text-gray-300 dark:text-gray-600 opacity-0 group-hover/rs:opacity-100 transition-opacity",
                    viewBox: "0 0 10 10"
                  }, [
                    b("path", {
                      d: "M1 1L9 9M1 5L5 9",
                      stroke: "currentColor",
                      "stroke-width": "1.5",
                      "stroke-linecap": "round"
                    })
                  ], -1)
                ])], 32)
              ], 64)) : $("", !0)
            ], 6), [
              [dt, !Ie.value]
            ]),
            b("div", {
              ref_key: "portalRef",
              ref: $t,
              class: "absolute inset-0 pointer-events-none"
            }, null, 512)
          ], 16)) : $("", !0)
        ]),
        _: 3
      }, 8, ["name"]),
      (d(), ve(Xt, { to: "body" }, [
        V(Be, {
          "enter-active-class": "transition-opacity duration-100",
          "leave-active-class": "transition-opacity duration-100",
          "enter-from-class": "opacity-0",
          "leave-to-class": "opacity-0"
        }, {
          default: se(() => [
            xe.value ? (d(), w("div", {
              key: 0,
              class: "fixed inset-y-0 w-1/2 z-[99999] pointer-events-none bg-primary/8 border-2 border-primary/30 rounded-lg",
              style: $e({ left: xe.value === "left" ? "var(--shell-sidebar-width, 0px)" : "50%" })
            }, null, 4)) : $("", !0)
          ]),
          _: 1
        })
      ]))
    ], 64));
  }
}), Qe = (e, i) => {
  const o = e.__vccOpts || e;
  for (const [u, y] of i)
    o[u] = y;
  return o;
}, Yt = /* @__PURE__ */ Qe(xi, [["__scopeId", "data-v-b15d7708"]]), ki = {
  key: 1,
  class: "px-6 py-4 border-b border-gray-100 dark:border-dark-200 shrink-0"
}, zi = { class: "text-lg font-bold text-gray-900 dark:text-gray-100 pr-6 wrap-break-word" }, Mi = {
  key: 2,
  class: "px-6 py-4 border-t border-gray-100 dark:border-dark-200 bg-gray-50/50 dark:bg-dark-100/50 flex justify-end gap-2 shrink-0"
}, Si = /* @__PURE__ */ he({
  __name: "BaseDrawer",
  props: {
    visible: { type: Boolean, default: !1 },
    header: {},
    position: { default: "right" },
    width: { default: "24rem" },
    height: { default: "50vh" },
    modal: { type: Boolean, default: !0 },
    closable: { type: Boolean, default: !0 },
    closeOnEscape: { type: Boolean, default: !0 },
    dismissableMask: { type: Boolean, default: !0 },
    blockScroll: { type: Boolean, default: !0 },
    contentClass: { default: "" },
    bodyClass: { default: "" },
    blurBackground: { type: Boolean, default: !1 },
    zIndex: { default: 2e3 }
  },
  emits: ["update:visible", "show", "hide", "after-hide"],
  setup(e, { emit: i }) {
    const o = e, u = i, y = O(() => {
      switch (o.position) {
        case "left":
          return "left-0 top-0 bottom-0 h-full drawer-panel-left";
        case "top":
          return "left-0 top-0 right-0 w-full drawer-panel-top";
        case "bottom":
          return "left-0 bottom-0 right-0 w-full drawer-panel-bottom";
        default:
          return "right-0 top-0 bottom-0 h-full drawer-panel-right";
      }
    }), M = O(() => {
      const r = {};
      return o.position === "left" || o.position === "right" ? r.width = o.width : r.height = o.height, r;
    }), W = () => {
      u("update:visible", !1);
    }, H = () => {
      o.dismissableMask && o.closable && W();
    }, R = () => {
      if (!o.blockScroll) return;
      const r = window.innerWidth - document.documentElement.clientWidth;
      r > 0 && (document.body.style.paddingRight = `${r}px`), document.documentElement.style.setProperty("overflow", "hidden", "important"), document.body.style.setProperty("overflow", "hidden", "important");
    }, T = () => {
      o.blockScroll && (document.documentElement.style.removeProperty("overflow"), document.body.style.removeProperty("overflow"), document.body.style.paddingRight = "");
    }, B = (r) => {
      o.visible && o.closeOnEscape && r.key === "Escape" && W();
    }, g = () => {
      R();
    }, t = () => {
      T(), u("after-hide");
    };
    return te(() => o.visible, (r) => {
      r ? (u("show"), R(), window.addEventListener("keydown", B)) : (u("hide"), window.removeEventListener("keydown", B));
    }, { immediate: !0 }), Ge(() => {
      o.visible && T(), window.removeEventListener("keydown", B);
    }), (r, p) => (d(), ve(Xt, { to: "body" }, [
      V(Be, {
        name: "drawer",
        appear: "",
        onBeforeEnter: g,
        onAfterLeave: t
      }, {
        default: se(() => [
          e.visible ? (d(), w("div", {
            key: 0,
            class: ee(["fixed inset-0", { "pointer-events-none": !e.modal }]),
            style: $e({ zIndex: e.zIndex })
          }, [
            e.modal ? (d(), w("div", {
              key: 0,
              class: ee(["fixed inset-0 bg-black/40 transition-opacity dialog-backdrop pointer-events-auto", { "backdrop-blur-[2px]": e.blurBackground }]),
              onClick: H
            }, null, 2)) : $("", !0),
            b("div", {
              class: ee(["fixed bg-white dark:bg-dark-50 shadow-2xl flex flex-col pointer-events-auto transition-transform duration-300 ease-in-out", [y.value, e.contentClass]]),
              style: $e(M.value),
              role: "dialog",
              "aria-modal": "true"
            }, [
              e.closable ? (d(), w("button", {
                key: 0,
                onClick: W,
                class: "absolute top-4 right-4 p-1 rounded-full text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 hover:bg-gray-100 dark:hover:bg-dark-200 transition-colors z-10"
              }, [
                V(Z, {
                  name: "X",
                  size: 14
                })
              ])) : $("", !0),
              r.$slots.header || e.header ? (d(), w("div", ki, [
                oe(r.$slots, "header", {}, () => [
                  b("h3", zi, Q(e.header), 1)
                ], !0)
              ])) : $("", !0),
              b("div", {
                class: ee(["flex-1 overflow-y-auto px-6 py-4 custom-scrollbar", e.bodyClass])
              }, [
                oe(r.$slots, "default", {}, void 0, !0)
              ], 2),
              r.$slots.footer ? (d(), w("div", Mi, [
                oe(r.$slots, "footer", {}, void 0, !0)
              ])) : $("", !0)
            ], 6)
          ], 6)) : $("", !0)
        ]),
        _: 3
      })
    ]));
  }
}), po = /* @__PURE__ */ Qe(Si, [["__scopeId", "data-v-ebd4852f"]]), xo = he({
  name: "ConfirmationDialog",
  inheritAttrs: !1,
  setup(e, { attrs: i, slots: o }) {
    return () => Gt(hn, i, o);
  }
}), Ii = { class: "py-2" }, Wi = {
  key: 0,
  class: "block text-xs text-gray-500 mb-2"
}, $i = ["placeholder", "maxlength"], Ci = ["disabled"], ko = /* @__PURE__ */ he({
  name: "InputDialog",
  __name: "InputDialog",
  props: {
    visible: { type: Boolean },
    header: {},
    label: { default: "" },
    placeholder: { default: "" },
    initialValue: { default: "" },
    confirmLabel: { default: "Confirm" },
    cancelLabel: { default: "Cancel" },
    maxLength: { default: 0 }
  },
  emits: ["confirm", "cancel", "update:visible"],
  setup(e, { emit: i }) {
    const o = e, u = i, y = C(""), M = C(null);
    te(() => o.visible, async (R) => {
      R && (y.value = o.initialValue, await Me(), M.value?.focus(), M.value?.select());
    });
    function W() {
      const R = y.value.trim();
      R && (u("confirm", R), u("update:visible", !1));
    }
    function H() {
      u("cancel"), u("update:visible", !1);
    }
    return (R, T) => (d(), ve(yn, {
      visible: e.visible,
      header: e.header,
      "max-width": "sm",
      "onUpdate:visible": H
    }, {
      footer: se(() => [
        b("button", {
          class: "px-4 py-2 text-sm text-gray-600 hover:text-gray-800 dark:text-gray-400 dark:hover:text-gray-200 transition-colors",
          onClick: H
        }, Q(e.cancelLabel), 1),
        b("button", {
          class: "px-4 py-2 text-sm bg-primary hover:bg-primary-600 text-white rounded-lg transition-colors disabled:opacity-40 disabled:cursor-not-allowed",
          disabled: !y.value.trim(),
          onClick: W
        }, Q(e.confirmLabel), 9, Ci)
      ]),
      default: se(() => [
        b("div", Ii, [
          e.label ? (d(), w("label", Wi, Q(e.label), 1)) : $("", !0),
          Je(b("input", {
            ref_key: "inputRef",
            ref: M,
            "onUpdate:modelValue": T[0] || (T[0] = (B) => y.value = B),
            type: "text",
            class: "w-full px-3 py-2 border rounded-lg focus:outline-none focus:border-primary dark:bg-dark-200 dark:border-dark-300 dark:text-white",
            placeholder: e.placeholder,
            maxlength: e.maxLength || void 0,
            onKeydown: [
              Lt(W, ["enter"]),
              Lt(H, ["escape"])
            ]
          }, null, 40, $i), [
            [vn, y.value]
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible", "header"]));
  }
}), Ti = { class: "flex items-center min-w-0 flex-1" }, Li = {
  key: 0,
  class: "w-0.5 h-4 rounded-full bg-primary shrink-0 mx-0.5"
}, Bi = ["onClick", "onDragstart", "onDragover", "onDragend"], Ei = { class: "truncate max-w-[80px]" }, Di = ["title", "aria-label", "onClick"], Ri = {
  key: "__drop-end",
  class: "flex items-center shrink-0"
}, Ai = {
  key: 0,
  class: "w-0.5 h-4 rounded-full bg-primary shrink-0 mx-0.5"
}, Hi = ["title", "aria-label"], Pi = {
  key: 0,
  class: "absolute right-0 top-full mt-1 z-50 bg-white dark:bg-dark-100 border border-gray-200 dark:border-white/10 rounded-lg shadow-lg py-1 min-w-[160px]"
}, Oi = ["onClick"], Gi = { class: "truncate" }, Fi = /* @__PURE__ */ he({
  __name: "DialogTabGroup",
  props: {
    group: {},
    labels: {}
  },
  emits: ["tab-close", "close", "tab-detach", "update:minimized"],
  setup(e, { emit: i }) {
    const o = {
      closeTab: "Close tab",
      allTabs: "All tabs",
      windowCount: (a) => `${a} windows`
    }, u = e, y = i, { setActive: M, reorderTab: W } = Ze(), H = C(!0), R = C(!1);
    function T() {
      H.value = !1;
    }
    const B = O(() => `tab-group-${u.group.id}`), g = O(() => ({ ...o, ...u.labels })), t = O(() => {
      const a = u.group.tabs.map((A) => A.title);
      return a.length <= 2 ? a.join(" + ") : g.value.windowCount(a.length);
    });
    function r(a) {
      R.value = a, y("update:minimized", a);
    }
    Ge(() => {
      h?.disconnect(), document.removeEventListener("mousedown", m);
    });
    const p = C(), f = C(), _ = C(!1), k = C(!1);
    function j() {
      p.value && (_.value = p.value.scrollWidth > p.value.clientWidth);
    }
    let h;
    Vt(() => {
      p.value && (h = new ResizeObserver(j), h.observe(p.value), j());
    }), te(() => u.group.tabs.length, () => Me(j));
    function m(a) {
      f.value && !f.value.contains(a.target) && (k.value = !1);
    }
    te(k, (a) => {
      a ? document.addEventListener("mousedown", m) : document.removeEventListener("mousedown", m);
    });
    const S = C(null), v = C(null);
    let D = !1;
    function K(a, A) {
      S.value = A, D = !1, a.dataTransfer.effectAllowed = "move";
    }
    function x(a, A) {
      if (S.value === null) return;
      a.preventDefault(), a.dataTransfer.dropEffect = "move";
      const z = a.currentTarget.getBoundingClientRect();
      v.value = a.clientX < z.left + z.width / 2 ? A : A + 1;
    }
    function c(a) {
      a.preventDefault(), D = !0;
      const A = S.value, z = v.value;
      if (S.value = null, v.value = null, A === null || z === null) return;
      const ae = z > A ? z - 1 : z;
      W(u.group.id, A, ae);
    }
    function I(a, A) {
      if (S.value = null, v.value = null, !D) {
        const z = p.value?.getBoundingClientRect();
        z && (a.clientX < z.left || a.clientX > z.right || a.clientY < z.top || a.clientY > z.bottom) && y("tab-detach", A);
      }
    }
    return (a, A) => (d(), ve(Yt, {
      visible: H.value,
      "window-id": B.value,
      title: t.value,
      icon: "LayoutGrid",
      minimizable: "",
      maximizable: "",
      mergeable: "",
      resizable: "",
      "resize-storage-key": "tab-group-dialog-size",
      "body-overflow": "hidden",
      "body-class": "!p-0",
      "max-width": "5xl",
      height: "480px",
      onClose: T,
      "onUpdate:minimized": r,
      onAfterHide: A[1] || (A[1] = (z) => y("close"))
    }, {
      header: se(() => [
        b("div", Ti, [
          b("div", {
            ref_key: "tabBarEl",
            ref: p,
            class: "flex items-center overflow-hidden min-w-0 flex-1"
          }, [
            V(mn, {
              tag: "div",
              class: "flex items-center",
              "move-class": "transition-transform duration-150 ease-out"
            }, {
              default: se(() => [
                (d(!0), w(ie, null, Se(e.group.tabs, (z, ae) => (d(), w("div", {
                  key: z.windowId,
                  class: "flex items-center shrink-0"
                }, [
                  v.value === ae && S.value !== null ? (d(), w("div", Li)) : $("", !0),
                  b("button", {
                    draggable: "true",
                    class: ee(["flex items-center gap-1 px-2 py-1 rounded-lg text-sm transition-colors shrink-0 group/tab", [
                      z.windowId === e.group.activeWindowId ? "bg-gray-100 dark:bg-dark-200 text-gray-900 dark:text-dark-text font-medium" : "text-gray-500 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-dark-200/50",
                      S.value === ae ? "opacity-40" : ""
                    ]]),
                    onClick: (de) => ne(M)(e.group.id, z.windowId),
                    onDragstart: N((de) => K(de, ae), ["stop"]),
                    onDragover: N((de) => x(de, ae), ["stop", "prevent"]),
                    onDrop: N(c, ["stop", "prevent"]),
                    onDragend: (de) => I(de, z.windowId)
                  }, [
                    V(Z, {
                      name: z.icon,
                      size: 13
                    }, null, 8, ["name"]),
                    b("span", Ei, Q(z.title), 1),
                    b("span", {
                      class: "ml-0.5 opacity-0 group-hover/tab:opacity-100 transition-opacity p-0.5 rounded hover:bg-gray-200 dark:hover:bg-dark-300",
                      title: g.value.closeTab,
                      "aria-label": g.value.closeTab,
                      onClick: N((de) => y("tab-close", z.windowId), ["stop"])
                    }, [
                      V(Z, {
                        name: "X",
                        size: 11
                      })
                    ], 8, Di)
                  ], 42, Bi)
                ]))), 128)),
                b("div", Ri, [
                  v.value === e.group.tabs.length && S.value !== null ? (d(), w("div", Ai)) : $("", !0)
                ])
              ]),
              _: 1
            })
          ], 512),
          e.group.tabs.length >= 2 ? (d(), w("div", {
            key: 0,
            ref_key: "tabMenuEl",
            ref: f,
            class: "relative shrink-0 ml-1"
          }, [
            b("button", {
              class: "flex items-center gap-1 px-2 py-1 rounded-md text-xs text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-dark-200 transition-colors",
              title: g.value.allTabs,
              "aria-label": g.value.allTabs,
              onClick: A[0] || (A[0] = (z) => k.value = !k.value)
            }, [
              V(Z, {
                name: "ChevronDown",
                size: 12
              }),
              b("span", null, Q(e.group.tabs.length), 1)
            ], 8, Hi),
            k.value ? (d(), w("div", Pi, [
              (d(!0), w(ie, null, Se(e.group.tabs, (z) => (d(), w("button", {
                key: z.windowId,
                class: ee(["flex items-center gap-2 w-full px-3 py-1.5 text-sm text-left transition-colors", z.windowId === e.group.activeWindowId ? "bg-gray-100 dark:bg-dark-200 text-gray-900 dark:text-dark-text font-medium" : "text-gray-600 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-dark-200/50"]),
                onClick: (ae) => {
                  ne(M)(e.group.id, z.windowId), k.value = !1;
                }
              }, [
                V(Z, {
                  name: z.icon,
                  size: 13
                }, null, 8, ["name"]),
                b("span", Gi, Q(z.title), 1)
              ], 10, Oi))), 128))
            ])) : $("", !0)
          ], 512)) : $("", !0)
        ])
      ]),
      default: se(() => [
        (d(!0), w(ie, null, Se(e.group.tabs, (z) => Je((d(), w("div", {
          key: z.windowId,
          class: "flex flex-col w-full h-full"
        }, [
          oe(a.$slots, z.windowId, {
            active: z.windowId === e.group.activeWindowId && !R.value
          })
        ])), [
          [dt, z.windowId === e.group.activeWindowId]
        ])), 128))
      ]),
      _: 3
    }, 8, ["visible", "window-id", "title"]));
  }
}), Vi = {
  key: 0,
  class: "fixed bottom-6 right-6 z-50 flex items-center gap-3 bg-white dark:bg-dark-100 rounded-lg shadow-lg border border-gray-200 dark:border-dark-200 px-4 py-3"
}, Xi = { class: "flex flex-col" }, ji = { class: "text-sm font-medium text-gray-900 dark:text-gray-100" }, _i = {
  key: 0,
  class: "text-xs text-gray-500 dark:text-gray-400"
}, Ki = {
  key: 0,
  class: "w-16"
}, Yi = { class: "w-full bg-gray-200 dark:bg-dark-200 rounded-full h-1.5 overflow-hidden" }, Ni = /* @__PURE__ */ he({
  __name: "LoadingIndicator",
  props: {
    visible: { type: Boolean, default: !1 },
    title: { default: "載入中" },
    message: { default: "" },
    showProgress: { type: Boolean, default: !1 },
    progress: { default: 0 }
  },
  setup(e) {
    return (i, o) => (d(), ve(Be, {
      "enter-active-class": "transition-opacity duration-300",
      "leave-active-class": "transition-opacity duration-300",
      "enter-from-class": "opacity-0",
      "enter-to-class": "opacity-100",
      "leave-from-class": "opacity-100",
      "leave-to-class": "opacity-0"
    }, {
      default: se(() => [
        e.visible ? (d(), w("div", Vi, [
          o[0] || (o[0] = b("div", { class: "relative" }, [
            b("div", { class: "w-5 h-5 border-2 border-gray-300 dark:border-dark-300 border-t-primary rounded-full animate-spin" }),
            b("div", { class: "absolute inset-0 w-5 h-5 border-2 border-transparent border-t-primary rounded-full animate-spin animation-delay-150" })
          ], -1)),
          b("div", Xi, [
            b("span", ji, Q(e.title || "載入中"), 1),
            e.message ? (d(), w("span", _i, Q(e.message), 1)) : $("", !0)
          ]),
          e.showProgress && e.progress !== void 0 ? (d(), w("div", Ki, [
            b("div", Yi, [
              b("div", {
                class: "bg-primary h-1.5 rounded-full transition-all duration-300 ease-out",
                style: $e({ width: e.progress + "%" })
              }, null, 4)
            ])
          ])) : $("", !0)
        ])) : $("", !0)
      ]),
      _: 1
    }));
  }
}), zo = /* @__PURE__ */ Qe(Ni, [["__scopeId", "data-v-297a7f0f"]]), Mo = /* @__PURE__ */ he({
  __name: "ToastNotification",
  setup(e) {
    return (i, o) => (d(), ve(bn));
  }
}), Ui = /* @__PURE__ */ he({
  __name: "WindowLoading",
  props: {
    visible: { type: Boolean },
    windowId: {},
    maximized: { type: Boolean },
    mergeable: { type: Boolean }
  },
  emits: ["update:visible", "after-hide"],
  setup(e) {
    const i = e, { windows: o } = Fe(), u = O(() => i.windowId ? o.value.get(i.windowId) : void 0);
    return (y, M) => (d(), ve(Yt, {
      visible: e.visible,
      "window-id": e.windowId,
      maximized: e.maximized ?? !1,
      title: u.value?.title ?? "",
      icon: u.value?.icon ?? "AppWindow",
      closable: !1,
      minimizable: !1,
      maximizable: !1,
      draggable: !1,
      "onUpdate:visible": M[0] || (M[0] = (W) => y.$emit("update:visible", W)),
      onAfterHide: M[1] || (M[1] = (W) => y.$emit("after-hide"))
    }, {
      default: se(() => [...M[2] || (M[2] = [
        b("div", { class: "flex items-center justify-center h-full" }, [
          b("div", { class: "w-8 h-8 rounded-full border-2 border-primary/30 border-t-primary animate-spin" })
        ], -1)
      ])]),
      _: 1
    }, 8, ["visible", "window-id", "maximized", "title", "icon"]));
  }
}), So = /* @__PURE__ */ he({
  name: "WindowHost",
  __name: "WindowHost",
  props: {
    saveWindowExitState: { type: Function },
    beforeMerge: { type: Function }
  },
  setup(e) {
    const i = e, { windows: o, setVisible: u, removeWindow: y } = Fe(), {
      groups: M,
      windowGroupMap: W,
      pendingMerge: H,
      createGroup: R,
      addToGroup: T,
      removeTab: B,
      dissolveGroup: g
    } = Ze(), t = O(
      () => [...o.value.values()].filter((m) => m.component && !W.value.get(m.id))
    );
    function r(m) {
      const S = o.value.get(m);
      return S ? { windowId: m, title: S.title, icon: S.icon } : null;
    }
    function p(m) {
      return m.startsWith("tab-group-") ? m.slice(10) : null;
    }
    te(H, (m) => {
      if (!m) return;
      H.value = null;
      const S = p(m.to), v = p(m.from), D = o.value.get(m.from), K = o.value.get(m.to);
      if (i.beforeMerge?.({
        ...m,
        fromWindow: D,
        toWindow: K,
        toGroupId: S,
        fromGroupId: v
      }) === !0) return;
      if (S) {
        const a = r(m.from);
        a && T(S, a);
        return;
      }
      if (v) {
        const a = r(m.to);
        a && T(v, a);
        return;
      }
      if (!D || !K) return;
      const c = W.value.get(m.from), I = W.value.get(m.to);
      c ? T(c, { windowId: m.to, title: K.title, icon: K.icon }) : I ? T(I, { windowId: m.from, title: D.title, icon: D.icon }) : R(
        { windowId: m.from, title: D.title, icon: D.icon },
        { windowId: m.to, title: K.title, icon: K.icon }
      );
    });
    function f(m, S) {
      S || (i.saveWindowExitState?.(m), u(m, !1));
    }
    function _(m) {
      B(m, { transfer: !0 }), u(m, !0);
    }
    function k(m) {
      y(m), B(m);
    }
    function j(m) {
      const S = M.value.find((v) => v.id === m);
      if (S) {
        for (const v of S.tabs)
          y(v.windowId);
        g(m), h.delete(m);
      }
    }
    const h = Ft(/* @__PURE__ */ new Map());
    return te(M, (m) => {
      const S = new Set(m.map((v) => v.id));
      for (const v of h.keys())
        S.has(v) || h.delete(v);
    }), (m, S) => (d(), w(ie, null, [
      (d(!0), w(ie, null, Se(t.value, (v) => (d(), ve(ut(v.component), st({
        key: v.id,
        visible: v.visible,
        "window-id": v.id
      }, { ref_for: !0 }, v.props, {
        maximized: v.windowState === "maximized",
        mergeable: !!v.contentComponent,
        "onUpdate:visible": (D) => f(v.id, D),
        onAfterHide: (D) => ne(y)(v.id)
      }), null, 16, ["visible", "window-id", "maximized", "mergeable", "onUpdate:visible", "onAfterHide"]))), 128)),
      (d(!0), w(ie, null, Se(ne(M), (v) => (d(), ve(Fi, {
        key: v.id,
        group: v,
        onTabClose: k,
        onTabDetach: _,
        onClose: (D) => j(v.id),
        "onUpdate:minimized": (D) => h.set(v.id, D)
      }, wn({ _: 2 }, [
        Se(v.tabs, (D) => ({
          name: D.windowId,
          fn: se(({ active: K }) => [
            ne(o).get(D.windowId)?.contentComponent ? (d(), ve(ut(ne(o).get(D.windowId)?.contentComponent), st({
              key: 0,
              "window-id": D.windowId,
              active: K
            }, { ref_for: !0 }, ne(o).get(D.windowId)?.props, { class: "flex-1 min-h-0 w-full h-full" }), null, 16, ["window-id", "active"])) : $("", !0)
          ])
        }))
      ]), 1032, ["group", "onClose", "onUpdate:minimized"]))), 128))
    ], 64));
  }
}), Ji = {
  key: 0,
  class: "luna-launcher-rail__separator",
  "aria-hidden": "true"
}, Zi = ["disabled", "title", "aria-label", "aria-current", "onClick"], Qi = {
  key: 0,
  class: "luna-launcher-rail__loading-ring",
  "aria-hidden": "true"
}, qi = {
  key: 1,
  class: "luna-launcher-rail__emoji",
  "aria-hidden": "true"
}, eo = {
  key: 4,
  class: "luna-launcher-rail__badge"
}, to = {
  key: 5,
  class: "luna-launcher-rail__open-dot",
  "aria-hidden": "true"
}, no = {
  key: 6,
  class: "luna-launcher-rail__minimized-ring",
  "aria-hidden": "true"
}, io = /* @__PURE__ */ he({
  __name: "LauncherRail",
  props: {
    items: {},
    sections: {},
    orientation: { default: "vertical" },
    activeId: {},
    loadingIds: {},
    openIds: {},
    minimizedIds: {},
    iconSize: { default: 20 },
    labels: {}
  },
  emits: ["launch"],
  setup(e, { emit: i }) {
    const o = e, u = i, y = O(() => ({
      minimizedSuffix: "minimized",
      ...o.labels
    })), M = O(() => o.sections?.length ? o.sections.filter((f) => f.items.length > 0) : o.items?.length ? [{ items: o.items }] : []), W = O(() => o.orientation === "vertical");
    function H(f) {
      return f.active ?? o.activeId === f.id;
    }
    function R(f) {
      return f.loading ?? o.loadingIds?.has(f.id) ?? !1;
    }
    function T(f) {
      return f.open ?? o.openIds?.has(f.id) ?? !1;
    }
    function B(f) {
      return f.minimized ?? o.minimizedIds?.has(f.id) ?? !1;
    }
    function g(f) {
      return typeof f == "object" || typeof f == "function" ? f : void 0;
    }
    function t(f) {
      return typeof f == "string" ? f : void 0;
    }
    function r(f) {
      return B(f) ? `${f.title} (${y.value.minimizedSuffix})` : f.title;
    }
    function p(f) {
      f.disabled || u("launch", f.id, f);
    }
    return (f, _) => (d(), w("nav", {
      class: ee(["luna-launcher-rail", W.value ? "luna-launcher-rail--vertical" : "luna-launcher-rail--horizontal"]),
      "aria-label": "Application launcher"
    }, [
      oe(f.$slots, "logo", {}, void 0, !0),
      oe(f.$slots, "before", {}, void 0, !0),
      (d(!0), w(ie, null, Se(M.value, (k, j) => (d(), w(ie, {
        key: k.id ?? j
      }, [
        j > 0 ? (d(), w("div", Ji)) : $("", !0),
        (d(!0), w(ie, null, Se(k.items, (h) => (d(), w("button", {
          key: h.id,
          type: "button",
          class: ee(["luna-launcher-rail__item", {
            "luna-launcher-rail__item--active": H(h),
            "luna-launcher-rail__item--open": T(h),
            "luna-launcher-rail__item--loading": R(h),
            "luna-launcher-rail__item--minimized": B(h)
          }]),
          disabled: h.disabled,
          title: r(h),
          "aria-label": r(h),
          "aria-current": H(h) ? "page" : void 0,
          onClick: (m) => p(h)
        }, [
          oe(f.$slots, "item", {
            item: h,
            active: H(h),
            loading: R(h),
            open: T(h),
            minimized: B(h),
            iconSize: e.iconSize,
            launch: () => p(h)
          }, () => [
            R(h) ? (d(), w("span", Qi, [..._[0] || (_[0] = [
              b("span", { class: "luna-launcher-rail__loading-spin" }, null, -1),
              b("span", { class: "luna-launcher-rail__loading-mask" }, null, -1)
            ])])) : $("", !0),
            h.emoji ? (d(), w("span", qi, Q(h.emoji), 1)) : g(h.icon) ? (d(), ve(ut(g(h.icon)), {
              key: 2,
              class: "luna-launcher-rail__icon",
              width: e.iconSize,
              height: e.iconSize,
              "aria-hidden": "true"
            }, null, 8, ["width", "height"])) : (d(), ve(Z, {
              key: 3,
              name: t(h.icon) ?? "AppWindow",
              size: e.iconSize,
              class: "luna-launcher-rail__icon"
            }, null, 8, ["name", "size"])),
            h.badge !== void 0 && h.badge !== "" ? (d(), w("span", eo, Q(h.badge), 1)) : $("", !0),
            !R(h) && T(h) && !H(h) ? (d(), w("span", to)) : $("", !0),
            B(h) ? (d(), w("span", no)) : $("", !0)
          ], !0)
        ], 10, Zi))), 128))
      ], 64))), 128)),
      oe(f.$slots, "after", {}, void 0, !0),
      oe(f.$slots, "footer", {}, void 0, !0)
    ], 2));
  }
}), Io = /* @__PURE__ */ Qe(io, [["__scopeId", "data-v-f0f414f5"]]);
function oo(e) {
  return typeof e == "function" ? e() : typeof e == "object" && e && "value" in e ? !!e.value : !!e;
}
function Wo(e = {}) {
  const i = Fe(), o = wt(), u = lt(e.loadingComponent ?? Ui), y = /* @__PURE__ */ new Map();
  async function M(t, r) {
    let p = y.get(t);
    if (!p) {
      const f = await r();
      p = lt(f.default), y.set(t, p);
    }
    return p;
  }
  function W(t) {
    const r = i.windows.value.get(t);
    r && (r.windowState === "minimized" && i.setWindowState(t, r.preMinimizeState ?? "floating"), i.setVisible(t, !0), i.setFocusedApp(t), o.focus(t));
  }
  function H(t) {
    if (oo(e.isMobile))
      for (const [r, p] of i.windows.value)
        r !== t && p.visible && i.setVisible(r, !1);
  }
  function R(t, r = t) {
    return e.getSavedWindowState?.(t, r) ?? null;
  }
  function T(t, r, p) {
    return i.windows.value.has(t) ? (r && i.setProps(t, r), p && i.setMeta(t, p), W(t), !0) : !1;
  }
  async function B(t) {
    const {
      loader: r,
      contentLoader: p,
      cacheKey: f = t.type,
      contentCacheKey: _ = `${f}:content`,
      focus: k = !0,
      loadingComponent: j = u,
      updateExistingProps: h,
      updateExistingMeta: m,
      ...S
    } = t;
    if (i.windows.value.has(S.id))
      return h && i.setProps(S.id, h), m && i.setMeta(S.id, m), k && W(S.id), S.id;
    const v = t.visible ?? !0;
    y.has(f) || i.openWindow({
      ...S,
      visible: v,
      component: lt(j)
    });
    const D = await M(f, r), K = p ? _ === f ? D : await M(_, p) : void 0, x = i.windows.value.get(S.id);
    return i.openWindow({
      ...x ?? S,
      visible: v,
      component: D,
      ...K && { contentComponent: K }
    }), k && W(S.id), S.id;
  }
  function g(t, r = !0) {
    return i.openWindow(t), r && W(t.id), t.id;
  }
  return {
    ...i,
    ...o,
    lazyComponent: M,
    openLazyWindow: B,
    openLoadedWindow: g,
    openExistingWindow: T,
    focusWindow: W,
    hideOtherWindowsOnMobile: H,
    getSavedWindowState: R,
    loadingComponent: u,
    lazyCache: y
  };
}
function Pe(e) {
  return typeof e == "function" ? e() : typeof e == "object" && e && "value" in e ? !!e.value : !!e;
}
function Ht(e, i) {
  e.value = /* @__PURE__ */ new Set([...e.value, i]);
}
function Pt(e, i) {
  const o = new Set(e.value);
  o.delete(i), e.value = o;
}
function $o(e) {
  const i = /* @__PURE__ */ new Map(), o = e.loadingApps ?? C(/* @__PURE__ */ new Set());
  function u(g, t) {
    i.set(g, t);
  }
  function y(g) {
    return i.get(g);
  }
  function M(g) {
    return e.canReopenOnMobile?.(g) ?? !0;
  }
  function W(g, t) {
    const r = e.getWindowInfo?.(g);
    return {
      title: r?.title ?? t?.title ?? g,
      icon: r?.icon ?? t?.icon ?? "Square"
    };
  }
  async function H(g, t, r) {
    if (e.shell.windows.value.has(t)) {
      r && g.buildProps && e.shell.setProps(t, g.buildProps(r)), e.shell.focusWindow(t);
      return;
    }
    if (!g.loader) {
      e.onMissingLoader?.(t, "open");
      return;
    }
    const p = W(t), f = e.shell.getSavedWindowState(t, t);
    await e.shell.openLazyWindow({
      id: t,
      type: t,
      title: p.title,
      icon: p.icon,
      loader: g.loader,
      cacheKey: t,
      windowState: Pe(e.isMobile) ? "maximized" : f?.windowState ?? g.defaultWindowState ?? "maximized",
      props: g.buildProps?.(r) ?? {},
      ...!Pe(e.isMobile) && f?.transform && { initialTransform: f.transform },
      focus: !1
    }), e.shell.focusWindow(t);
  }
  async function R(g, t) {
    if (!g.loader) {
      e.onMissingLoader?.(t.type, "reopen");
      return;
    }
    const r = W(t.type, { title: t.title, icon: t.icon });
    await e.shell.openLazyWindow({
      id: t.id,
      type: t.type,
      title: r.title,
      icon: r.icon,
      loader: g.loader,
      cacheKey: t.id,
      windowState: Pe(e.isMobile) ? "maximized" : t.windowState ?? g.defaultWindowState ?? "maximized",
      props: e.buildReopenProps?.(t, g) ?? (t.meta ? { restoreState: t.meta } : {}),
      ...!Pe(e.isMobile) && t.transform && { initialTransform: t.transform },
      ...t.preMinimizeState && { preMinimizeState: t.preMinimizeState },
      focus: !1
    });
  }
  async function T(g, t) {
    if (!g) {
      e.shell.setFocusedApp(null);
      return;
    }
    const r = y(g);
    if (!r) {
      e.onMissingSpec?.(g);
      return;
    }
    if (!await (e.beforeLaunch?.(g, t, r) ?? !0)) return;
    const f = e.shouldHideOthersOnLaunch?.(g) ?? !1;
    f && e.shell.hideOtherWindowsOnMobile(g);
    const _ = !e.shell.windows.value.has(g);
    _ && Ht(o, g);
    try {
      r.open ? await r.open(t) : await H(r, g, t);
    } finally {
      _ && Pt(o, g);
    }
    f && e.shell.focusWindow(g);
  }
  async function B(g, t, r, p, f, _, k, j, h = !1) {
    const m = y(t);
    if (m) {
      if (Pe(e.isMobile) && !M(t)) return;
      h || Ht(o, g);
      try {
        const S = { id: g, type: t, meta: r, title: p, icon: f, windowState: _, transform: k, preMinimizeState: j };
        await (m.reopen?.(S) ?? R(m, S));
      } finally {
        h || Pt(o, g);
      }
      return;
    }
    e.onMissingSpec?.(t);
  }
  return {
    loadingApps: o,
    registerApp: u,
    getAppSpec: y,
    canReopenOnMobile: M,
    launchApp: T,
    reopenWindow: B,
    openGeneric: H,
    reopenGeneric: R
  };
}
function Oe(e) {
  return typeof e == "function" ? e() : typeof e == "object" && e && "value" in e ? !!e.value : !!e;
}
function Ot(e) {
  return typeof e == "function" ? e() : e;
}
function ao() {
  return {
    getItem: (e) => globalThis.localStorage?.getItem(e) ?? null,
    setItem: (e, i) => {
      globalThis.localStorage?.setItem(e, i);
    },
    removeItem: (e) => {
      globalThis.localStorage?.removeItem(e);
    },
    keys: () => {
      const e = [], i = globalThis.localStorage;
      if (!i) return e;
      for (let o = 0; o < i.length; o += 1) {
        const u = i.key(o);
        u && e.push(u);
      }
      return e;
    }
  };
}
function rt(e) {
  return !!e && (e.x !== 0 || e.y !== 0);
}
function lo(e) {
  return e.windowState ?? (e.minimized ? "minimized" : e.maximized === !1 ? "floating" : "maximized");
}
function ro(e, i) {
  !e || i.length === 0 || (e.value = /* @__PURE__ */ new Set([...e.value, ...i]));
}
function so(e, i) {
  if (!e || i.length === 0) return;
  const o = new Set(e.value);
  for (const u of i) o.delete(u);
  e.value = o;
}
function Co(e) {
  const { windows: i, getWindowTransform: o, setFocusedApp: u } = Fe(), { groups: y, createGroup: M, addToGroup: W, setActive: H } = Ze(), { zStack: R } = wt(), T = e.storage ?? ao(), B = e.debounceMs ?? 500;
  let g = null;
  function t() {
    const x = T.getItem(Ot(e.storageKey));
    if (!x) return null;
    const c = JSON.parse(x);
    return c.v === 1 ? c : null;
  }
  function r(x) {
    T.setItem(Ot(e.storageKey), JSON.stringify(x));
  }
  function p() {
    const x = /* @__PURE__ */ new Map();
    try {
      const c = t();
      for (const I of c?.windows ?? [])
        I.transform && x.set(I.id, I.transform);
    } catch {
    }
    return x;
  }
  function f(x = p()) {
    return [...i.value.values()].filter((c) => e.shouldPersistWindow?.(c) ?? !0).map((c) => {
      const I = o(c.id) ?? x.get(c.id), a = R.value.indexOf(c.id);
      return {
        id: c.id,
        type: c.type,
        title: c.title,
        icon: c.icon,
        visible: c.visible,
        ...a >= 0 && { zOrder: a },
        ...c.meta && { meta: c.meta },
        ...c.props && { props: c.props },
        ...c.windowState && { windowState: c.windowState },
        ...c.preMinimizeState && { preMinimizeState: c.preMinimizeState },
        ...rt(I) && { transform: I }
      };
    });
  }
  function _() {
    return y.value.filter((x) => x.tabs.some((c) => {
      const I = i.value.get(c.windowId);
      return !!I && I.visible && (e.shouldPersistWindow?.(I) ?? !0);
    })).map((x) => ({
      windowIds: x.tabs.filter((c) => {
        const I = i.value.get(c.windowId);
        return !!I && I.visible && (e.shouldPersistWindow?.(I) ?? !0);
      }).map((c) => c.windowId),
      activeWindowId: x.activeWindowId
    })).filter((x) => x.windowIds.length >= 2);
  }
  function k(x = f()) {
    if (!(!e.exitStateKey || Oe(e.isMobile)))
      try {
        const c = JSON.parse(T.getItem(e.exitStateKey) ?? "{}");
        for (const I of x) {
          const a = i.value.get(I.id);
          if (!a) continue;
          const A = a.windowState === "minimized" ? a.preMinimizeState ?? "floating" : a.windowState ?? "maximized", z = o(a.id) ?? I.transform;
          c[a.type] = {
            windowState: A,
            ...rt(z) && { transform: z }
          };
        }
        T.setItem(e.exitStateKey, JSON.stringify(c));
      } catch {
      }
  }
  function j() {
    try {
      const x = f(), c = {
        v: 1,
        windows: x,
        groups: _(),
        ...R.value.at(-1) && { lastFocusedId: R.value.at(-1) }
      };
      r(c), k(x);
    } catch {
    }
  }
  function h() {
    g !== null && clearTimeout(g), g = setTimeout(j, B);
  }
  function m(x) {
    const c = [...x.windows].sort((I, a) => (I.zOrder ?? 0) - (a.zOrder ?? 0));
    if (Oe(e.isMobile)) {
      const I = x.lastFocusedId ?? c.at(-1)?.id;
      return c.filter((a) => a.id === I).slice(0, 1);
    }
    return c.filter((I) => I.visible !== !1);
  }
  async function S(x) {
    await Me();
    for (const c of x.groups) {
      if (c.windowIds.length < 2) continue;
      const [I, a, ...A] = c.windowIds;
      if (!I || !a) continue;
      const z = i.value.get(I), ae = i.value.get(a);
      if (!z || !ae) continue;
      const de = M(
        { windowId: I, title: z.title, icon: z.icon },
        { windowId: a, title: ae.title, icon: ae.icon }
      );
      for (const Ve of A) {
        const Te = i.value.get(Ve);
        Te && W(de, { windowId: Ve, title: Te.title, icon: Te.icon });
      }
      c.windowIds.includes(c.activeWindowId) && H(de, c.activeWindowId);
    }
  }
  async function v() {
    try {
      e.beforeRestore?.(T);
      const x = t();
      if (!x) return { status: "none" };
      if (x.windows.length === 0) return { status: "empty" };
      const c = e.shouldRestoreWindow ? [...x.windows].sort((a, A) => (a.zOrder ?? 0) - (A.zOrder ?? 0)).filter((a) => e.shouldRestoreWindow?.(a, x) ?? !0) : m(x);
      if (c.length === 0) return { status: "empty" };
      const I = c.map((a) => e.mapRestoredWindowId?.(a) ?? a.id);
      ro(e.loadingApps, I);
      try {
        await Promise.all(c.map((a, A) => {
          const z = Oe(e.isMobile) ? "maximized" : lo(a);
          return e.reopenWindow({
            savedWindow: a,
            restoredId: I[A],
            windowState: z,
            transform: Oe(e.isMobile) ? void 0 : a.transform
          });
        }));
      } finally {
        so(e.loadingApps, I);
      }
      return R.value = I.filter((a) => i.value.has(a)), await S(x), x.lastFocusedId && i.value.has(x.lastFocusedId) && u(x.lastFocusedId), { status: "restored", lastFocusedId: x.lastFocusedId };
    } catch {
      return { status: "none" };
    }
  }
  function D(x) {
    if (!e.exitStateKey || Oe(e.isMobile)) return;
    const c = i.value.get(x);
    if (!(!c || !(e.shouldPersistWindow?.(c) ?? !0)))
      try {
        const I = JSON.parse(T.getItem(e.exitStateKey) ?? "{}"), a = c.windowState === "minimized" ? c.preMinimizeState ?? "floating" : c.windowState ?? "maximized", A = o(x);
        I[c.type] = {
          windowState: a,
          ...rt(A) && { transform: A }
        }, T.setItem(e.exitStateKey, JSON.stringify(I));
      } catch {
      }
  }
  const K = te([i, y], h);
  return {
    readLayout: t,
    writeLayout: r,
    saveLayout: j,
    scheduleSave: h,
    restoreLayout: v,
    saveWindowExitState: D,
    stop: K,
    storage: T
  };
}
function uo(e) {
  return {
    loader: e.loader,
    defaultWindowState: e.defaultWindowState,
    buildProps: e.buildProps,
    open: e.open,
    reopen: e.reopen
  };
}
function To(e, i) {
  for (const o of i)
    e.registerApp(o.id, uo(o));
}
function Lo(e, i = {}) {
  return {
    id: e.id,
    title: e.title,
    icon: e.icon,
    emoji: e.emoji,
    placement: e.placement,
    meta: e.meta,
    ...i
  };
}
export {
  yn as BaseDialog,
  po as BaseDrawer,
  Yt as BaseWindow,
  xo as ConfirmationDialog,
  Fi as DialogTabGroup,
  yo as EXIT_STATE_KEY,
  ko as InputDialog,
  Io as LauncherRail,
  zo as LoadingIndicator,
  Mo as ToastNotification,
  So as WindowHost,
  Ui as WindowLoading,
  Po as confirmQueue,
  $o as createAppWindowRegistry,
  Co as createWindowLayoutPersistence,
  Wo as createWindowShell,
  Do as disableCloseWatcherPath,
  jt as dockRef,
  Bt as getDockTarget,
  Ro as getMobileCloseStack,
  Dt as isDraggingWindow,
  To as registerShellApps,
  Cn as registerTeardown,
  Fo as removeToast,
  bo as runAllTeardowns,
  ho as setDockTarget,
  uo as toAppWindowSpec,
  Lo as toLauncherItem,
  Vo as toasts,
  Oo as useConfirmDialog,
  Nn as useIsMobile,
  zn as useMinimizedWindows,
  Ao as useMobileHistoryEntry,
  Xo as useToast,
  wt as useWindowManager,
  Fe as useWindowRegistry,
  Ze as useWindowTabs
};
